import fetch from 'auth/FetchInterceptor'

const DashboardService = {}

DashboardService.getAnalyticsData = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics',
        method: 'post',
        data,
    })
}

DashboardService.getAnalyticsGraph = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetAnalyticsGraph',
        method: 'post',
        data,
    })
}

DashboardService.getFtmData = function (params) {
    const queryString = new URLSearchParams(params).toString()

    return fetch({
        url:
            process.env.REACT_APP_API_URL +
            `messageTrace/MaintenanceLogs/GetErrorCounts` +
            (queryString ? `?${queryString}` : ''),
        method: 'get',
    })
}

DashboardService.getFtmDataWithChargePoints = function (params) {
    const queryString = new URLSearchParams(params).toString()

    return fetch({
        url:
            process.env.REACT_APP_API_URL +
            `messageTrace/MaintenanceLogs/GetErrorCountsWithChargePoints` +
            (queryString ? `?${queryString}` : ''),
        method: 'get',
    })
}

DashboardService.getFtmDataWithChargePointsByVendorErrorCode = function (params) {
    const queryString = new URLSearchParams(params).toString()

    return fetch({
        url:
            process.env.REACT_APP_API_URL +
            `messageTrace/MaintenanceLogs/GetErrorCountsWithChargePointsByVendorErrorCode` +
            (queryString ? `?${queryString}` : ''),
        method: 'get',
    })
}

DashboardService.getFtmDataToExcel = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'messageTrace/MaintenanceLogs/GetErrorCountsExcel',
        method: 'get',
        responseType: 'blob',
        params,
    })
}

DashboardService.getFtmTableData = function (params) {
    return fetch({
        url:
            process.env.REACT_APP_API_URL +
            `messageTrace/MaintenanceLogs/GetErrorCountsDynamic?index=${params.index}&size=10`,
        method: 'post',
        data: params.finalQuery,
    })
}

//executive dashboard

DashboardService.getModelBreakdown = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/ModelBreakdown',
        method: 'get',
        params,
    })
}

DashboardService.getChargePointsDeployed = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetChargePointsDeployed',
        method: 'get',
        params,
    })
}

DashboardService.getConnectorStatus = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetConnectorStatus',
        method: 'get',
        params,
    })
}

DashboardService.getInitialPower = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetInitialPower',
        method: 'get',
        params,
    })
}

DashboardService.getTotalTransactionDuration = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetTotalTransactionDuration',
        method: 'get',
        params,
    })
}

DashboardService.getUtilizationRatios = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetUtilizationRatios',
        method: 'get',
        params,
    })
}

DashboardService.getOperatorsChargePointsBreakdown = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetOperatorsChargePointsBreakdown',
        method: 'get',
        params,
    })
}

DashboardService.getTotalTransactionAnalytics = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetTotalTransactionAnalytics',
        method: 'get',
        params,
    })
}

DashboardService.getTransactionForDashboard = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetTransactionForDashboard?range=Monthly&rangeCount=12',
        method: 'get',
        params,
    })
}

DashboardService.getTotalInstalledPower = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/analytics/GetTotalInstalledPower',
        method: 'get',
        params,
    })
}

DashboardService.getUptimeRatios = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'messageTrace/OcppLogs/GetUptimeRatios?rangeType=3&rangeCount=12',
        method: 'get',
        params,
    })
}

DashboardService.getAverageUptimes = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'messageTrace/OcppLogs/GetAverageUptimes',
        method: 'get',
        params,
    })
}

DashboardService.getExecutiveDashboard = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/analytics/GetExecutiveDashboard`,
        method: 'get',
        params,
    })
}

DashboardService.getExecutiveDashboardLive = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/ExecutiveDashboard/Live`,
        method: 'get',
        params,
    })
}

DashboardService.getExecutiveDashboardSummary = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/ExecutiveDashboard/Summary`,
        method: 'get',
        params,
    })
}

DashboardService.getExecutiveChargePointDashboardLive = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/ExecutiveChargePointDashboard/Live`,
        method: 'post',
        data,
    })
}

DashboardService.getExecutiveChargePointDashboardSummary = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/ExecutiveChargePointDashboard/Summary`,
        method: 'post',
        data,
    })
}

export default DashboardService
